var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useNavigate } from 'react-router-dom';
import { Box, Modal, ModalContent, ModalHeader, ModalOverlay, Button, Flex, Spacer, } from 'shared/components/ui';
export var InternalMemberWarningModal = function (_a) {
    var intMembWarningDisclosure = _a.intMembWarningDisclosure, setWarningAccepted = _a.setWarningAccepted, memberName = _a.memberName, memberInitials = _a.memberInitials;
    var modalContentProps = {
        padding: 5,
    };
    var modalHeaderProps = {
        fontSize: '27px',
        fontWeight: '600',
        padding: 0,
    };
    var navigate = useNavigate();
    function acceptWarning() {
        intMembWarningDisclosure.onClose();
        setWarningAccepted(true);
    }
    return (_jsxs(Modal, __assign({ isOpen: intMembWarningDisclosure.isOpen, onClose: intMembWarningDisclosure.onClose, size: "xl", isCentered: true }, { children: [_jsx(ModalOverlay, {}), _jsxs(ModalContent, __assign({}, modalContentProps, { children: [_jsx(Box, { children: _jsxs(ModalHeader, __assign({}, modalHeaderProps, { children: ["View ", memberName, "'s data?"] })) }), _jsx(Box, __assign({ mt: 3, fontWeight: 700 }, { children: "This client is a Spring Health employee, or a dependent of a Spring Health employee." })), _jsx(Box, __assign({ mt: 3 }, { children: "Please use your discretion. Only view their data if you absolutely must." })), _jsxs(Flex, __assign({ mt: 3 }, { children: [_jsx(Button, __assign({ isFullWidth: true, variant: "secondary", onClick: function () {
                                    navigate('/notes/upcoming');
                                } }, { children: "Go to My Notes" })), _jsx(Spacer, {}), _jsxs(Button, __assign({ isFullWidth: true, variant: "primary", onClick: function () {
                                    acceptWarning();
                                } }, { children: ["View data for ", memberInitials] }))] }))] }))] })));
};
